const FavouritesList = function(dispatcher, options) {

    this.popup = null;
    this.addToFavPopup = '';
    let _this = this;

    this.init = () => {
        if (typeof addToFavEnabled === "undefined") {
            return;
        }
        this.iconHoverLogic();
        this.createBlankOverlay();
        document.getElementById("favourites_click").addEventListener("click", (event) => {
            this.showOverlay();
            this.openFavList();

            return false;
        });

        document.getElementById("add-to-fav-ok").addEventListener("click", (event) => {
            dispatcher.dispatch('dialog_confirm', {
                title: "Save Url",
                body: "Are you sure you want to save this page?",
                confirm_text: "Save",
                confirm_event: "save-url",
                options: {}
            });
        });

        document.getElementById("remove-from-list").addEventListener("click", (event) => {
            const url = btoa(document.getElementById('url-displayed').value);
            const label = document.getElementById('user-url-label').value;

            const xhttp = new XMLHttpRequest();
            xhttp.open("POST", `${removeFromList}/${userID}/${url}/${label}` , true);
            xhttp.send();
            this.closeFavList();
            this.toggleAddingPanel(true);
            this.toggleRemovingPanel(false);
            this.setPointerIconState();
        });

        document.querySelectorAll(".dialog-confirm-cancel").forEach(function(elem) {
            elem.addEventListener("click", function() {
                _this.closeFavList();
            });
        });
    }

    dispatcher.on('save-url', (data) => {
        this.saveUrl();
        this.closeFavList();
        this.toggleAddingPanel(false);
        this.toggleRemovingPanel(true);
        this.setPointerIconState();
    });

    this.iconHoverLogic = () => {
        const icon = document.getElementById('favourites_click').getElementsByTagName('i')[0];
        icon.addEventListener("mouseenter", (event) => {
                event.target.style.color = "purple";
            },
            false,
        );

        icon.addEventListener("mouseleave", (event) => {
                event.target.style.color = "";
            },
            false,
        );
    }

    this.setPointerIconState = () => {
        const iconContainer = document.getElementById('favourites');
        const icon = iconContainer.getElementsByTagName('i')[0];

        if (iconContainer.classList.contains('added-to-list')) {
            iconContainer.classList.remove('added-to-list');
            icon.classList.remove('fas');
            icon.classList.add('far');
            return;
        }
        iconContainer.classList.add('added-to-list');
        icon.classList.remove('far');
        icon.classList.add('fas');
    }

    this.toggleAddingPanel = (visible) => {
        const panel = document.getElementById('save-new-page');
        if (!visible) {
            panel.style.display = 'none';
            return;
        }
        panel.style.display = 'block';
    };

    this.toggleRemovingPanel = (visible) => {
        const panel = document.getElementById('remove-page');
        if (!visible) {
            panel.style.display = 'none';
            return;
        }
        panel.style.display = 'block';
    }

    this.saveUrl = (a, b) => {
        const url = btoa(document.getElementById('url-displayed').value);
        const label = document.getElementById('user-url-label').value;
        const xhttp = new XMLHttpRequest();


        xhttp.open("POST", `${addToFavouritesSend}/${userID}/${url}/${label}` , true);
        xhttp.send();
    }

    this.openFavList = () => {
        const currentUrl = window.location.href;
        this.addToFavPopup = document.getElementById('addToFav');
        this.addToFavPopup.style.display = "block";
        document.getElementById('url-displayed').value = currentUrl;
    }

    this.closeFavList = () => {
        this.hideOverlay();
        if (!this.addToFavPopup) {
            return;
        }
        this.addToFavPopup.style.display = "none";
        const checkbox = document.getElementById("web-push-do-not-display")
    }

    this.createBlankOverlay = () => {
        if (document.getElementById('mainOverlay') !== null) {
            return;
        }
        const overlayDiv = document.createElement("div");
        overlayDiv.setAttribute('id', 'mainOverlay');
        document.body.appendChild(overlayDiv);
    };

    this.showOverlay = () => {
        document.getElementById("mainOverlay").style.display = "block";
        document.body.classList.add("no-scroll");
    };

    this.hideOverlay = () => {
        document.getElementById("mainOverlay").style.display = "none";
        document.body.classList.remove("no-scroll");
    };

    document.addEventListener("DOMContentLoaded", () => {
        document.body.addEventListener("click", function(event) {
            if (event.target.id === 'mainOverlay') {
                this.closeWebPush();
            }
        }.bind(this));
    });
};

export { FavouritesList }
